//import { getTmplName } from 'helper/utils';
const computeWidths = (breakPoint) => {
	let val;
	switch (breakPoint) {
		case 'jumbo': // > 1440
			val = [144, 424, 208, 208, 208, 208, 24];
			break;
		case 'xxl': // > 1440
			val = [144, 424, 208, 208, 208, 208, 24];
			break;
		case 'xl': // < 1440
			val = [88, 424, 120, 120, 125, 125, 24];
			break;
		case 'lg':
			val = [120, 312, 80, 80, 112, 112, 16];
			break;
		case 'md': // < 768
			val = [72, 159, 90, 95, 112, 112, 16];
			break;
		case 'sm':
			val = [104, 216, 240, 96, 144, 144, 48];
			break;
	}
	return val;
};

const computeWidthsForSavedTable = (breakPoint) => {
	let val;
	switch (breakPoint) {
		case 'jumbo': // > 1440
			val = [756, 400, 180, 24];
			break;
		case 'xxl': // > 1440
			val = [756, 400, 180, 24];
			break;
		case 'xl': // < 1440
			val = [756, 400, 180, 24];
			break;
		case 'lg':
			val = [756, 400, 180, 24];
			break;
		case 'md': // < 768
			val = [756, 400, 180, 24];
			break;
		case 'sm':
			val = [756, 400, 180, 24];
			break;
	}
	return val;
};

const computeFontSize = (breakPoint) => {
	let val;
	switch (breakPoint) {
		case 'jumbo': // > 1920
		case 'xxl': // > 1440
		case 'xl': // < 1440
		case 'lg':
			val = 18;
			break;
		case 'md': // < 768
		case 'sm':
			val = 16;
			break;
	}
	return val;
};

const computeHeight = (breakPoint) => {
	let val;
	switch (breakPoint) {
		case 'jumbo':
			val = 56;
			break;
		case 'xxl':
			val = 56;
			break;
		case 'xl':
			val = 56;
			break;
		case 'lg':
			val = 56;
			break;
		case 'md':
			val = 48;
			break;
		case 'sm':
			val = 48;
			break;
	}
	return val;
};

const selectedTempDetials = (selectedView, selectedTemp) => {
	// let data = templateData.filter((item) => item.templateName === getTmplName(rowData?.templateId));

	return {
		templateId: selectedTemp?.templateId,
		view: selectedView,
		filter: selectedTemp?.filter,
		filterWeekly: selectedTemp?.filterWeekly,
		filterWeeklyMultiWindow: selectedTemp?.filterWeeklyMultiWindow
	};
};
export {
	computeWidths,
	computeWidthsForSavedTable,
	computeHeight,
	computeFontSize,
	selectedTempDetials
};
n